<template>
  <div class="hr-change-record">
    <header-top :headerText="headerText" haveTab></header-top>
    <el-tabs v-model="activeName" @tab-click="handleTabChange">
      <el-tab-pane label="全部记录" name="all"></el-tab-pane>
      <el-tab-pane label="待审核" name="waiting"></el-tab-pane>
      <el-tab-pane label="已通过" name="success"></el-tab-pane>
      <el-tab-pane label="已驳回" name="refuse"></el-tab-pane>
    </el-tabs>
    <div class="change-main">
      <div class="main-top">
        <div class="top-left">
          <div class="day-module">
            <el-button @click="inToday">今天</el-button>
            <el-button @click="inYesterday">昨天</el-button>
            <el-button @click="inSevenDays">近7天</el-button>
            <el-date-picker
              align="center"
              v-model="dateRange"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              @change="changeDate"
            ></el-date-picker>
          </div>
          <el-select
            @change="getChangeRecordsList"
            v-model="query.changeType"
            clearable
            placeholder="异动类型"
          >
            <el-option
              v-for="item in changeType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="top-right">
          <el-input
            :placeholder="searchText"
            v-model="query.Filter"
            class="input-with-select"
            @keyup.enter.native="getChangeRecordsList"
          >
            <el-select v-model="searchText" slot="prepend" placeholder="请选择" @change="changeFilter">
              <el-option label="全文搜索" value="全文搜索"></el-option>
              <el-option label="前缀搜索" value="按异动记录关键字搜索"></el-option>
              <el-option label="按提交人" value="按提交人搜索"></el-option>
              <el-option label="按审核人" value="按审核人搜索"></el-option>
            </el-select>
            <i
              class="el-icon-search el-input__icon input__suffix"
              slot="suffix"
              @click="getChangeRecordsList"
            ></i>
          </el-input>
          <el-popover placement="top" title width="25" height="49" trigger="hover" content="刷新">
            <div slot="reference">
              <div @click="refresh">
                <svg-icon class="svg" icon-class="refresh-ico" />
              </div>
            </div>
          </el-popover>
          <el-popover placement="top" title width="25" height="49" trigger="hover" content="设置">
            <div slot="reference">
              <div @click="isFiltrateShow = true">
                <svg-icon class="svg" icon-class="filtrate-ico" />
              </div>
            </div>
          </el-popover>
          <!-- <div @click="derive">
            <svg-icon class="svg" icon-class="derive-ico" />
          </div> -->
        </div>
      </div>
      <div class="main-table">
        <el-table
          :data="changeRecordTable"
          @sort-change="changeSort"
          style="width: 100%"
          header-align="center"
        >
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column
            prop="description"
            label="员工异动记录"
            show-overflow-tooltip
            width="600"
            v-if="tableTitleKey.includes('员工异动记录')"
          />
          <el-table-column
            prop="effectiveTime"
            label="生效日期"
            v-if="tableTitleKey.includes('生效日期')"
            align="center"
            width="170"
          ></el-table-column>
          <el-table-column
            prop="creator"
            label="提交人"
            width="70"
            align="center"
            v-if="tableTitleKey.includes('提交人')"
          ></el-table-column>
          <el-table-column
            prop="creationTime"
            label="提交时间"
            v-if="tableTitleKey.includes('提交时间')"
            align="center"
            sortable="custom"
            width="170"
          ></el-table-column>
          <el-table-column
            prop="more"
            label="备注"
            align="center"
            show-overflow-tooltip
            v-if="tableTitleKey.includes('备注')&&activeName!='refuse'"
          >
            <template slot-scope="scope">{{scope.row.more|nullValue}}</template>
          </el-table-column>
          <el-table-column
            prop="more"
            label="驳回原因"
            align="center"
            show-overflow-tooltip
            v-if="activeName=='refuse'"
          >
            <template slot-scope="scope">{{scope.row.refusedReason|nullValue}}</template>
          </el-table-column>
          <el-table-column
            prop="reviewer"
            label="审核人"
            width="70"
            align="center"
            v-if="tableTitleKey.includes('审核人') &&activeName!='waiting'"
          >
            <template slot-scope="scope">{{scope.row.reviewer|nullValue}}</template>
          </el-table-column>
          <el-table-column
            prop="reviewTime"
            label="审核时间"
            v-if="tableTitleKey.includes('审核时间') &&activeName!='waiting'"
            align="center"
            sortable="custom"
            width="170"
          >
            <template slot-scope="scope">{{scope.row.reviewTime|nullValue}}</template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            v-if="activeName=='waiting'"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button @click.native.prevent="check(scope.row.id)" type="text" >审核</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100"
            v-if="activeName=='refuse'"
            align="center"
          >
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button @click.native.prevent="cancel(scope.row.id)" type="text" >撤回</el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img src="../../../../assets/image/loading.png" alt="loading" class="loading-ico" />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading&&!changeRecordTable.length">列表为空</div>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="自定义列表字段"
      :visible.sync="isFiltrateShow"
      width="800px"
      :before-close="handleClose"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :filter-method="filterMethod"
        :titles="['请选择你想显示的列表字段', '已选择字段']"
        filter-placeholder="请输入字段名称"
        v-model="tableTitleKey"
        :data="tabTitData"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isFiltrateShow = false">取 消</el-button>
        <el-button type="primary" @click="isFiltrateShow = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="异动驳回"
      :visible.sync="isRejectShow"
      width="550px"
      custom-class="employe-dialog"
      @close="handleClose('rejectForm')"
    >
      <el-form
        :model="rejectForm"
        label-position="left"
        label-width="4rem"
        ref="rejectForm"
        :rules="rejectRules"
      >
        <el-form-item label="驳回原因" prop="reason" class="auto-height">
          <el-input
            type="textarea"
            v-model="rejectForm.reason"
            maxlength="200"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isRejectShow = false">取消</el-button>
        <el-button type="primary" @click="submitReject('rejectForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="异动审核" :visible.sync="isCheckShow" width="450px" custom-class="employe-dialog">
      是否通过审核？
      <div slot="footer" class="dialog-footer">
        <el-button @click="refuse">驳回</el-button>
        <el-button type="primary" @click="pass">通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";

import {
  getChangeRecords,
  changeRecordsReview,
  changeRecordsCancel,
} from "@/http/api/employe";
import { dateFormat } from "../../../../common/filters";
export default {
  components: {
    headerTop,
  },
  data() {
    const generateData = (_) => {
      const data = [];
      const tabTits = [
        "员工异动记录",
        "生效日期",
        "提交人",
        "提交时间",
        "审核人",
        "审核时间",
        "备注",
      ];
      const pinyin = [
        "gangweixinxitiaozheng",
        "shengxiaoriqi",
        "tijiaoren",
        "tijiaoshijian",
        "shenheren",
        "shenheshijian",
        "beizhu",
      ];
      tabTits.forEach((tabTit, index) => {
        data.push({
          label: tabTit,
          key: tabTit,
          pinyin: pinyin[index],
        });
      });
      return data;
    };
    return {
      tabTitData: generateData(),
      isFiltrateShow: false,
      tableTitleKey: [
        "员工异动记录",
        "生效日期",
        "提交人",
        "提交时间",
        "审核人",
        "审核时间",
        "备注",
      ],
      permissions: this.$store.getters.permissions,
      headerText: "员工异动记录",
      activeName: "all",
      searchText: "全文搜索",
      dateRange: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
        new Date(),
      ],
      changeType: [
        {
          value: "joining",
          label: "入职异动",
        },
        {
          value: "jobchange",
          label: "岗位异动",
        },
        {
          value: "regular",
          label: "转正异动",
        },
        {
          value: "firing",
          label: "离职异动",
        },
      ],
      isLoading: true,
      changeRecordTable: [],
      query: {
        Condition: "",
        Filter: "",
        startTime: null,
        endTime: null,
        changeType: null,
        reviewStatus: null,
        status: null,
        timeCondition: "CreationTime",
        maxResultCount: 30,
        skipCount: 0,
        sorting: "",
      },
      rejectForm: {
        reason: "",
      }, // 驳回表单
      rejectRules: {
        reason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      }, // 驳回规则
      isRejectShow: false,
      isCheckShow: false,
      checkId: "",
      totalCount: 1,
      pageIndex: 1,
    };
  },
  mounted() {
    this.getChangeRecordsList();
  },
  methods: {
    changeFilter(val) {
      if (val == "全文搜索") {
        this.query.Condition = "";
      } else if (val == "按异动记录关键字搜索") {
        this.query.Condition = "Description";
      } else if (val == "按提交人搜索") {
        this.query.Condition = "Creator";
      } else if (val == "按审核人搜索") {
        this.query.Condition = "Reviewer";
      }
    },
    changeSort(val) {
      this.query.sorting = `${val.prop} ${
        val.order == "descending" ? "desc" : "asc"
      }`;
      this.getChangeRecordsList();
    },
    // 审核回调
    check(id) {
      if (this.permissions["RocketIdentity.Users.JobChangeReview"]) {
        this.checkId = id;
        this.isCheckShow = true;
      } else {
        this.$message.warning({
          message: `您暂无员工异动审核权限`,
          showClose: true,
        });
      }
    },
    refuse() {
      this.isCheckShow = false;
      this.isRejectShow = true;
    },
    pass() {
      changeRecordsReview(this.checkId, {
        reviewStatus: "success",
      })
        .then((res) => {
          if (res) {
            this.$message.success({ message: "审核通过", showClose: true });
          }
          this.getChangeRecordsList();
        })
        .catch((err) => {
          if (err.code === 10604) {
            this.$message.error({
              message: "该员工不存在，审核无效",
              showClose: true,
            });
          }
        });
      this.isCheckShow = false;
    },
    // 驳回确认回调
    submitReject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            reviewStatus: "refuse",
            refusedReason: this.rejectForm.reason,
          };
          changeRecordsReview(this.checkId, data)
            .then((res) => {
              if (res) {
                this.$message.success({ message: "驳回成功", showClose: true });
              }
              this.getChangeRecordsList();
            })
            .catch((err) => {
              if (err.code === 10604) {
                this.isCheckShow = false;
                this.$message.error({
                  message: "该员工不存在，驳回无效",
                  showClose: true,
                });
              }
            });
          this.isRejectShow = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    //时间搜索
    changeDate(val) {
      if (this.dateRange) {
        this.query.startTime = this.dateRange[0];
        this.query.endTime = this.dateRange[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      this.getChangeRecordsList();
    },
    getChangeRecordsList() {
      this.isLoading = true;
      this.changeRecordTable = [];
      if (this.dateRange) {
        this.query.startTime = this.dateRange[0];
        this.query.endTime = this.dateRange[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      if (this.query.startTime) {
        this.query.startTime = dateFormat(this.query.startTime);
      }
      if (this.query.endTime) {
        this.query.endTime = dateFormat(this.query.endTime);
      }
      this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      getChangeRecords(this.query).then((res) => {
        this.totalCount = res.result.totalCount;
        var data = res.result.items;
        this.changeRecordTable = data;
        this.isLoading = false;
      });
    },
    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1 || item.label.indexOf(query) > -1;
    },
    handleClose(v) {
      this.isFiltrateShow = false;
      if (v) {
        this.$refs[v].resetFields();
      }
    },
    refresh() {
      //console.log("刷新");
      this.getChangeRecordsList();
    },
    derive() {
      //console.log("导出");
    },
    inToday() {
      let startTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      let endTime = new Date();
      this.dateRange = [startTime, endTime];
      this.getChangeRecordsList();
    },
    inYesterday() {
      let startTime = new Date(
        new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 - 1000
      );
      let endTime = new Date(new Date().setHours(0, 0, 0, 0) - 1);
      this.dateRange = [startTime, endTime];
      this.getChangeRecordsList();
    },
    inSevenDays() {
      let startTime = new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 7);
      let endTime = new Date();
      this.dateRange = [startTime, endTime];
      this.getChangeRecordsList();
    },
    handleCurrentChange(val) {
      // //console.log("跳转的指定页", val);
      this.query.skipCount = (val - 1) * this.query.maxResultCount;
      this.getChangeRecordsList();
    },
    handleSizeChange(val) {
      // //console.log("更改的页面数量", val);
      this.query.maxResultCount = val;
      this.getChangeRecordsList();
    },
    handleTabChange() {
      this.activeName == "all"
        ? (this.query.reviewStatus = null)
        : (this.query.reviewStatus = this.activeName);
      this.pageIndex = 1;
      this.getChangeRecordsList();
    },
    // 撤回回调
    cancel(id) {
      if (this.permissions["RocketIdentity.Users.JobChangeCancel"]) {
        this.$confirm(`是否撤回该异动？`, "撤回提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            changeRecordsCancel(id)
              .then((res) => {
                this.getChangeRecordsList();
              })
              .catch((err) => {
                if (err.code === 10604) {
                  this.isCheckShow = false;
                  this.$message.error({
                    message: "该员工不存在，撤回无效",
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: `您暂无员工异动撤回权限`,
          showClose: true,
        });
      }
    },
    // 再次提交
    againChange(row) {
      this.$confirm(`是否再次提交该异动？`, "再次提交提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          changeRecordsReview(row.id, {
            reviewStatus: "waiting",
          }).then((res) => {
            if (res) {
              this.$message.success({ message: "已再次提交", showClose: true });
            }
            this.getChangeRecordsList();
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.hr-change-record {
  ::v-deep .el-tabs {
    background-color: #fff;
    margin-top: -5px;
    .el-tabs__header {
      background-color: transparent;
      border-bottom: 1px solid #ddd;
    }

    .el-tabs__content {
      padding: 0;
    }
  }

  .change-main {
    padding: 20px;

    .main-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-bottom: 10px;
      height: 30px;

      .top-left {
        display: flex;
        align-items: center;
        height: 100%;

        .el-button {
          margin: 0;
          border-right-color: transparent;
          height: 30px;

          &:focus {
            border-right-color: $--color-primary;
          }
        }

        .el-select {
          margin-left: 10px;
          width: 120px;
        }
      }

      .top-right {
        display: flex;
        align-items: center;
        justify-content: space-between;

        margin-right: 7px;
        height: 100%;
        width: 450px;

        .input-with-select .el-select {
          width: 120px;
        }
        .svg-icon{
          margin: 0 10px;
        }
      }

      .el-select {
        .el-input {
          width: 90px;
        }
      }
    }

    .main-table {
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
      background-color: #fff;
      padding-bottom: 15px;

      .el-table {
        margin-bottom: 15px;
      }
    }
  }

  ::v-deep .employe-dialog {
    .el-dialog__header {
      padding: 25px 25px 20px 25px;
    }

    .el-dialog__body {
      padding: 0 25px;
    }

    .el-dialog__footer {
      padding: 15px 25px 25px 25px;
    }
  }
}
</style>